import { dataIdFromObject } from '@sketch/graphql-cache'

// Components
import { handleFetchMore } from '@sketch/components'

// Hooks
import { useFlag } from '@sketch/modules-common'
import { useSortingSettings } from 'modules/shares/hooks/useSortSettings'
import { useOnEvent } from '@sketch/utils'

// Types
import { useGetCollectionSharesQuery } from '@sketch/gql-types'
import { ShareSearchFilter } from 'modules/shares/hooks/useSearchFilters'

interface UseCollectionProps {
  projectId: string
  collectionId: string
  search?: string
  filters?: ShareSearchFilter[]
}

// Helpers
const entriesPath = ['project', 'collection', 'shares', 'entries']

export const useCollectionsShares = ({
  projectId,
  collectionId,
  search,
  filters = [],
}: UseCollectionProps) => {
  const isSearchFilterSortOn = useFlag('search-filter-sort')
  const { sort } = useSortingSettings()

  const {
    data,
    loading,
    error,
    fetchMore,
    refetch,
  } = useGetCollectionSharesQuery({
    variables: {
      projectIdentifier: projectId,
      collectionIdentifier: collectionId,
      search: {
        name: search,
        filters,
      },
      after: null,
      sortOrder: isSearchFilterSortOn ? sort : undefined,
    },
  })

  const after = data?.project.collection.shares.meta.after || null

  const loadMoreHandler = handleFetchMore(fetchMore, entriesPath, {
    dataIdFromObject,
    after,
  })

  useOnEvent('workspaceShareRefresh', ({ collectionIdentifier }) => {
    if (collectionIdentifier === collectionId) {
      refetch()
    }
  })

  return {
    project: data?.project,
    loading,
    error,
    fetchMore: loadMoreHandler,
  }
}
